
export class FolderStructure {
  folderStructure: Folder[];
}
export class Folder {
  folderId: number;
  folderName: string;
  subFolders: SubFolder[];
}
export class TooltipInfo {
  documents: string;
  subFolders: string;
}
export class SubFolder {
  subFolderId: number;
  subFolderName: string;
  documentType: DocumentType[];
}

export class DocumentType {
  documentTypeName: string;
  controlAttributes: string;
  shorthand: string;
}

export interface SupplierDetails {
  supplierName: string;
  organizationCode: string;
  division: string;
  isActive: boolean;
  email: string;
  isDeleted: boolean;
  comments: string;
  hasFolderStructure: boolean;
  id: string;
  createdUtc: Date;
  lastModifiedUtc: Date;
  createdBy: string;
  lastModifiedBy: string;
}
export interface SupplierPerformanceFilter {
  buyer: string;
  itemCode: string;
  planner: string
}

export interface SolarForms {
  formId: string;
  formName: string;
  formNumber: string;
  description: string;
  filePath: string;
  isActive: boolean;
  isDeleted: boolean;
  category: string;
  file: File;
  createdBy: string;
  lastModifiedBy: string;
  createdUtc: string;
  lastModifiedUtc: string;
  extension: string;
}

export class UploadFile {
  supplierId: string;
  fileName: string;
  filePath: string;
  documentType: string;
  comments: string;
  solarPartNumber: string;
  file: FormData;
  purchaseOrder: string = "";
  shipmentDate: string = "";
  heatLot: string = "";
  batch: string = "";
  materials: string = "";
  mainFolderId: any;
  subFolderId: any;
  subFolderName: string;
}
export class FirstItem {
  documentTypeString: string;
  shortCode: string;
  displayValue: string;
  controlAttributes: string;
  namingConvention:string;
  isMPApplicable?: boolean;
  commonControlAttributes?: commonControlAttributes[];
}

export class commonControlAttributes {
  controlName: string;
  controlDetail: controlDetail;
}

export class controlDetail {
  controlType: string;
  controlHint: string;
  maxLength: string;
  controlData: string;
}

export class DocumentsTypeByPath {
  item1: FirstItem[];
  item2: FirstItem[];
  filterList?: FirstItem[];
}

export interface DocumentsDetails {
  id: string;
  name: string;
  uploadedBy: string;
  uploadedOn: string;
  solarPartNumber: string;
  purchaseOrder: string;
  serialNumber: string;
  docType: Boolean
}

export interface DocumentsDetailsRawData {
  fileId: string;
  filePath: string;
  uiDocumentAttributesDTO: {
    documentAttributes: {
      documentTypeId: number;
      documentType: string;
      documentName: string;
      comments: string;
      documentSuffix: string;
      additionalInformation: {
          batchNumber: string;
          commodity: string;
          damageDescription: string;
          damagedQuantity: string;
          dateOfPresentation: string | null;
          deliveryDate: string | null;
          descriptionOfDocument: string;
          descriptionOfMaterial: string;
          deviations: string | null;
          dimensions: string;
          dueDate: string | null;
          effectivityDate: string | null;
          exclusivityAgreements: string | null;
          expiration: string | null;
          expirationDate: string | null;
          heatLotNumber: string;
          intellectualProperty: string | null;
          leakTest: string
          materialComposition: string;
          month: string;
          numberOfContainers: string;
          pickUpDate: string | null;
          ppapNumber: string;
          pprnUmber: string;
          preassureTest: string;
          projectNumber: string;
          purchaseOrder: string;
          typeofCertification: string;
          quantity: string;
          tags: string[];
          revisionNumber: string;
          rtaNumber: string;
          serialNumber:string;
          serviceType:string;
          shipmentDate: string;
          shippedQuantity: string;
          solarPartNumber: string;
          termsOfConditions: string;
          timeFrame:string | null;
          trackingNumber:string;
          typeofAlert: string;
          valueOfClaim: string;
          valueStream: string;
          weight: string;
          workAtCustomerSite: null
          year: string;
          rnNumber: string;
          rmaNumber: string;
          pdNumber: string;
          tcNumber: string;
          icmNumber: string;
          netWeightLbs: string;
          grossWeightLbs: string;
          loadTestRequired: string;
          actualLoadTestWeightLbs: string;
          ratedLiftCapacityLbs: string;
          pressureTestRequired: string;
          pressurePsi: string;
          invoiceDate: string | null;
          invoiceNumber: string;
          typeOfClaim: string;
          ppapLevel: string;
          documentExpirationDate: string | null;
      };
    };
  };
  isActive: false;
  createdUtc: string;
  createdBy: string;
  lastModifiedUtc: string;
  lastModifiedBy: string;
  isDeleted: boolean;
  comments: string;
  mainFolderId: number;
  subFolderId: number;
  documentName: string;
  supplierId: string
}

export class GetDocumentTypesRequest {
  folderPath: string;
  supplierId: string;
}

export class GetMaterialMetaData {
  material: string;
  isActive: boolean;
  isDeleted: boolean;
  id: string;
  createdUtc: Date;
  lastModifiedUtc: Date;
  createdBy: string;
  lastModifiedBy: string;
}

export class IsFileExists {
  fileName: string;
  filePath: string;
  fileId?: string;
}

export class FolderSubFoldersTransform {
  name: string;
  uploadOn: string;
  uploadBy: string;
  id?: string;
  subFolders?: SubFolder[];
  documentType?: [];
  docType: boolean

}
export class FileUploadPathByDocumentType {
  supplierId: string;
  documentType: string;
}
export class GetFilePathByDocumentType {
  supplierId: string;
  documentType: string;
}
export class AdditionalInformation {
  showBlock: boolean;
  purchaseOrderNumber: boolean;
  shipmentDate: boolean;
  heatLotNumber: boolean;
  materialNumber: boolean;
  batchNumber: boolean;
  serialNumber: boolean;
  solarPartNumber: boolean;
}

export interface FileDetails {
  purchaseOrderNumbers: number;
  serialNumbers: number;
  solarPartNumbers: string;
  documentName: string;
  documentType: string;
  createdBy: string;
  supplierId: string;
  lastModifiedBy: string;
}

export interface FileDetailsRawData {
  fileId: string;
  filePath: string;
  uiDocumentAttributesDTO: {
    documentAttributes: {
      documentTypeId: number;
      documentType: string;
      documentName: string;
      documentSuffix: string;
      comments: string;
      additionalInformation: {
        solarPartNumbers: string;
        serialNumbers: string;
        purchaseOrderNumbers: string;
        heatLot: string;
        batch: string;
        shipmentDate: string;
        materials: string;
      };
    };
  };
  isActive: false;
  createdUtc: string;
  createdBy: string;
  lastModifiedUtc: string;
  lastModifiedBy: string;
  isDeleted: boolean;
  comments: string;
  mainFolderId: number;
  subFolderId: number;
  documentName: string;
  supplierId: string;
  extension: string;
}

export class DocumentApiValues {
  documentDays: number;
  role: string;
  supplier: string;
}

export class SaveGridState {
  rowData: [];
  gridOptions: []
}
